import { ORPCError } from "@orpc/client";
import type { ReviewType } from "#shared/reviewsContract.ts";
import type { ReviewPerspective } from "./questionPhrasing.ts";

export type ReviewVertical = "people" | "team" | "org/employees";

export const PERSPECTIVE_BY_REVIEW_TYPE: Record<ReviewType, ReviewPerspective> = {
    SelfReview: "self",
    ManagerReview: "manager",
    PeerReview: "peer",
    UpwardReview: "upward"
};

const REVIEW_TYPE_BY_PERSPECTIVE: Record<ReviewPerspective, ReviewType> = {
    self: "SelfReview",
    manager: "ManagerReview",
    peer: "PeerReview",
    upward: "UpwardReview"
};

function isPerspective(segment: string): segment is ReviewPerspective {
    return Object.hasOwn(REVIEW_TYPE_BY_PERSPECTIVE, segment);
}

export function resolveWritePerspective(segment: string | undefined) {
    const perspective = segment && isPerspective(segment) ? segment : undefined;

    return { perspective, reviewType: perspective ? REVIEW_TYPE_BY_PERSPECTIVE[perspective] : undefined };
}

export function buildReviewDetailsPath(vertical: ReviewVertical, revieweeId: string, cycleId: string) {
    return `/${vertical}/${revieweeId}/reviews/${cycleId}`;
}

export function buildReviewWritePath(vertical: ReviewVertical, revieweeId: string, cycleId: string, reviewType: ReviewType) {
    return `${buildReviewDetailsPath(vertical, revieweeId, cycleId)}/${PERSPECTIVE_BY_REVIEW_TYPE[reviewType]}`;
}

export const REVIEW_GOOD_VIBE_SEGMENT = "good-vibes";

export function buildReviewSharePreviewPath(vertical: ReviewVertical, revieweeId: string, cycleId: string) {
    return `${buildReviewDetailsPath(vertical, revieweeId, cycleId)}/share`;
}

export function isReviewerRefusal(error: unknown) {
    return error instanceof ORPCError && error.code === "FORBIDDEN";
}
